import { get, post, put, fileDown} from "@/utils/request";

import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getEventList = data =>
  post(`${riskApi}/risk/riskOrder/findEventList`, data);

export const getEventExport = (data, fileName) =>
  fileDown(`${riskApi}/risk/riskOrder/exportEventExcel`, data, fileName);
  